import { useRequiredContext } from "@redotech/react-util/context";
import { RETURNS_CONSOLIDATED_SETTINGS_PATH } from "@redotech/redo-settings-common/flat-team-settings/returns/settings-paths";
import { MerchantRoutesContext } from "../merchant-routes";
import {
  RETURNS_SETTINGS_TAB_BY_LEGACY_PATH,
  RETURNS_SETTINGS_TAB_QUERY_PARAM,
  type ReturnsSettingsTab,
} from "./returns-settings-tab";
import { useReturnsSettingsExperience } from "./use-returns-settings-experience";

export function returnsSettingsTabPath(tab: ReturnsSettingsTab): string {
  return `${RETURNS_CONSOLIDATED_SETTINGS_PATH}?${RETURNS_SETTINGS_TAB_QUERY_PARAM}=${tab}`;
}

/** Where a page under an old returns page goes back to: the tab that replaced it for a merchant on the new page, else the old page. */
export function returnsSettingsParentPath(
  legacyPath: string,
  useNewUi: boolean,
): string {
  const tab = RETURNS_SETTINGS_TAB_BY_LEGACY_PATH[legacyPath];
  return useNewUi && tab ? returnsSettingsTabPath(tab) : legacyPath;
}

export function useReturnsSettingsParentHref(legacyPath: string): string {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { useNewUi } = useReturnsSettingsExperience();
  return routes.getSettingsSubRoute(
    returnsSettingsParentPath(legacyPath, useNewUi),
  );
}
